import { useEffect } from "react";

const NIGHT_START = 19; // 7pm
const NIGHT_END   = 6;  // 6am
const STORAGE_KEY = "ethos_evening_mode"; // 'on' | 'off' | null(auto)
const EVENT = "ethos-evening-change";

function isNightTime() {
  const h = new Date().getHours();
  return h >= NIGHT_START || h < NIGHT_END;
}

/** Manual override: 'on' (forced evening), 'off' (forced day), null (automatic). */
export function getEveningOverride() {
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
}

/** Set the manual evening override and notify listeners. mode: 'on' | 'off' | null */
export function setEveningOverride(mode) {
  try {
    if (mode === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, mode);
  } catch { /* ignore */ }
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVENT));
}

/** Resolved evening state — manual override wins, otherwise time-based. */
export function isEveningActive() {
  const o = getEveningOverride();
  if (o === "on") return true;
  if (o === "off") return false;
  return isNightTime();
}

/**
 * Circadian sanctuary mode.
 * Sets data-night="true" on <html> automatically between 7pm–6am (local device time),
 * unless the user has set a manual Evening mode override ('on'/'off').
 * Re-checks every minute and reacts instantly to manual toggles.
 */
export function useCircadianMode() {
  useEffect(() => {
    function apply() {
      document.documentElement.setAttribute("data-night", isEveningActive() ? "true" : "false");
    }
    apply();
    const interval = setInterval(apply, 60_000);
    window.addEventListener(EVENT, apply);
    window.addEventListener("storage", apply);
    return () => {
      clearInterval(interval);
      window.removeEventListener(EVENT, apply);
      window.removeEventListener("storage", apply);
    };
  }, []);
}
